import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b6b475e6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=b6b475e6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b475e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b475e6')) {
      api.createRecord('b6b475e6', component.options)
    } else {
      api.reload('b6b475e6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=b6b475e6&scoped=true", function () {
      api.rerender('b6b475e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/mallManagement/orderList/list.vue"
export default component.exports